import React from 'react';
import PropTypes from 'prop-types';
import { PTBBCarousel, PTBBCarouseSliderSettings } from '../../prop-types.js';
import Slider from '../../../../../01_atoms/Slider';
import Spinner from '../../../../../01_atoms/Spinner';
import DefaultPicture from '../../../../../01_atoms/DefaultPicture';
import { generateClassNameByBehaviorSettings } from '../../../../../../utils/behaviorSettings';

const BBCarouselDesktopStandard = ({
  items,
  sliderSettings,
  activeSlideIndex,
  transitioning,
  bbCarouselStyles,
  behaviorSettings,
  uuid,
}) => {
  const componentName = 'bb-carousel--desktop--standard';

  const classes = [
    'bb',
    bbCarouselStyles['bb-carousel'],
    bbCarouselStyles['bb-carousel--desktop'],
    bbCarouselStyles['bb-carousel--desktop--standard'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid} data-component={componentName}>
      <div className="container">
        <Slider {...sliderSettings}>
          {items.map((item, i) => (
            <div
              className={`item ${bbCarouselStyles['bb-carousel__item']}`}
              key={`image-${item.title}-${i}`}
            >
              <DefaultPicture {...item.image} />
            </div>
          ))}
        </Slider>

        <div
          className={`${bbCarouselStyles['bb-carousel__overlay']} ${items[activeSlideIndex].cta ? 'cta' : ''}`}
        >
          <div className={bbCarouselStyles['bb-carousel__gradient']} />
          <div className={bbCarouselStyles['bb-carousel__counter']}>
            {transitioning ? (
              <Spinner />
            ) : (
              <p>
                <strong>
                  {activeSlideIndex + 1}/{items.length}
                </strong>
              </p>
            )}
          </div>

          {items.map((item, i) => (
            <div
              key={`text-${item.title}-${i}`}
              className={`${bbCarouselStyles['bb-carousel__text']} ${i === activeSlideIndex ? '' : 'd-none'} ${
                transitioning ? 'faded' : ''
              }`}
            >
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

BBCarouselDesktopStandard.propTypes = {
  ...PTBBCarousel,
  ...PTBBCarouseSliderSettings,
  activeSlideIndex: PropTypes.number.isRequired,
  transitioning: PropTypes.bool.isRequired,
};

export default BBCarouselDesktopStandard;
